import { setPromoVehicleParts } from '../setPromoVehicleParts'
import { setLoading } from '../setLoading'
import { setError } from '../setError'
import { VehiclPartsListApi } from '../../api'

export const fetchPromoVehicleParts = (fields) => async (dispatch, getState) => {
  try {
    dispatch(setError(''))
    dispatch(setLoading(true))

    const api = new VehiclPartsListApi()
    const { products, totalCount, totalPages, currentPage, seo, message, error } = await api.getPromoProducts(fields)

    if (Array.isArray(products)) {
      dispatch(setPromoVehicleParts(products))
    } else {
      dispatch(setPromoVehicleParts([]))
    }

    if (error) dispatch(setError(error?.message || ''))

    dispatch(setLoading(false))
  } catch (e) {
    console.error('fetchVehicleParts error', e)
    dispatch(setError(error?.message || ''))
    dispatch(setPromoVehicleParts([]))
    dispatch(setLoading(false))
  }
}
